module.exports = __webpack_public_path__ + "media/images/powerpoint/kantar-366-background-45035f8f85518b7bc90a73428a269014.png";